import { HeaderState } from 'models/HeaderState';
import { createSelector } from 'reselect';
import { MultiQuantity } from 'models/MultiQuantity';

const getCartItems = (state: HeaderState) => state.cart.cartItems;

export const getCheckoutLink = (state: Pick<HeaderState, 'appShell'>) =>
  state.appShell.links.checkout;

export const getCartItemQuantity = createSelector(getCartItems, cartItems =>
  cartItems.reduce((quantity, cartItem) => quantity + cartItem.quantity.amount, 0)
);

export const isMultiQuantity = (quantity: unknown): quantity is MultiQuantity =>
  Boolean((quantity as MultiQuantity).factor);
